import { superficieDaPosicao } from "./keyword-link";

type MedicaoSource = {
  measuredAt?: string | null;
  serpMeasuredAt?: string | null;
  serpRanking?: number | null;
};

/** Acima disso a medição já não descreve o presente e precisa aparecer datada. */
const DIAS_PARA_AVISAR = 30;

const MESES = [
  "jan",
  "fev",
  "mar",
  "abr",
  "mai",
  "jun",
  "jul",
  "ago",
  "set",
  "out",
  "nov",
  "dez",
];

/**
 * Aviso datado para posição velha. As palavras do motor antigo estão paradas
 * desde 01/2026 e apareciam como se fossem de hoje — cliente via "1º lugar"
 * de janeiro achando que era a posição atual.
 */
export const textoDaMedicao = (
  keyword: MedicaoSource,
  hoje: Date = new Date(),
): string | null => {
  const quando =
    superficieDaPosicao(keyword) === "pesquisa"
      ? keyword.serpMeasuredAt
      : keyword.measuredAt;
  if (!quando) return null;

  const medida = new Date(quando);
  if (Number.isNaN(medida.getTime())) return null;

  const dias = (hoje.getTime() - medida.getTime()) / 86_400_000;
  if (dias < DIAS_PARA_AVISAR) return null;

  const ano = String(medida.getFullYear()).slice(-2);
  return `medida em ${MESES[medida.getMonth()]}/${ano}`;
};
